import "./manhoodedit.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper";
import { images } from "../../constants";

const ManhoodEdit = () => {
  return (
    <section className="manhood-cont">
      <h3>MAMAHOOD EDIT</h3>
      <Swiper
        slidesPerView={3}
        spaceBetween={30}
        pagination={{
          clickable: true,
        }}
        modules={[Pagination]}
        className="mySwiper"
      >
        <SwiperSlide>
          <div className="blog-item">
            <img src={images.Manhood1} alt="Manhood-1" />
            <div className="info-div">
              <h4>Nutrition for Pregnancy: Watch your plate before you eat</h4>
              <p className="details">By Preggerz | Apr 10, 2022</p>
              <p>
                During pregnancy, your body undergoes lot of physical and
                harmonal changes. These changes reflect on your physical and
                emotional health, further manifesting into various health
                issues.
              </p>
              <p className="link">Read More</p>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="blog-item">
            <img src={images.Manhood2} alt="Manhood-2" />
            <div className="info-div">
              <h4>Nutrition for Pregnancy: Watch your plate before you eat</h4>
              <p className="details">By Preggerz | Apr 10, 2022</p>
              <p>
                During pregnancy, your body undergoes lot of physical and
                harmonal changes. These changes reflect on your physical and
                emotional health, further manifesting into various health
                issues.
              </p>
              <p className="link">Read More</p>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="blog-item">
            <img src={images.Manhood3} alt="Manhood-3" />
            <div className="info-div">
              <h4>Nutrition for Pregnancy: Watch your plate before you eat</h4>
              <p className="details">By Preggerz | Apr 10, 2022</p>
              <p>
                During pregnancy, your body undergoes lot of physical and
                harmonal changes. These changes reflect on your physical and
                emotional health, further manifesting into various health
                issues.
              </p>
              <p className="link">Read More</p>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="blog-item">
            <img src={images.Manhood4} alt="Manhood-4" />
            <div className="info-div">
              <h4>Nutrition for Pregnancy: Watch your plate before you eat</h4>
              <p className="details">By Preggerz | Apr 10, 2022</p>
              <p>
                During pregnancy, your body undergoes lot of physical and
                harmonal changes. These changes reflect on your physical and
                emotional health, further manifesting into various health
                issues.
              </p>
              <p className="link">Read More</p>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="blog-item">
            <img src={images.Manhood5} alt="Manhood-5" />
            <div className="info-div">
              <h4>Nutrition for Pregnancy: Watch your plate before you eat</h4>
              <p className="details">By Preggerz | Apr 10, 2022</p>
              <p>
                During pregnancy, your body undergoes lot of physical and
                harmonal changes. These changes reflect on your physical and
                emotional health, further manifesting into various health
                issues.
              </p>
              <p className="link">Read More</p>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="blog-item">
            <img src={images.Manhood6} alt="Manhood-6" />
            <div className="info-div">
              <h4>Nutrition for Pregnancy: Watch your plate before you eat</h4>
              <p className="details">By Preggerz | Apr 10, 2022</p>
              <p>
                During pregnancy, your body undergoes lot of physical and
                harmonal changes. These changes reflect on your physical and
                emotional health, further manifesting into various health
                issues.
              </p>
              <p className="link">Read More</p>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="blog-item">
            <img src={images.Manhood7} alt="Manhood-7" />
            <div className="info-div">
              <h4>Nutrition for Pregnancy: Watch your plate before you eat</h4>
              <p className="details">By Preggerz | Apr 10, 2022</p>
              <p>
                During pregnancy, your body undergoes lot of physical and
                harmonal changes. These changes reflect on your physical and
                emotional health, further manifesting into various health
                issues.
              </p>
              <p className="link">Read More</p>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="blog-item">
            <img src={images.Manhood8} alt="Manhood-8" />
            <div className="info-div">
              <h4>Nutrition for Pregnancy: Watch your plate before you eat</h4>
              <p className="details">By Preggerz | Apr 10, 2022</p>
              <p>
                During pregnancy, your body undergoes lot of physical and
                harmonal changes. These changes reflect on your physical and
                emotional health, further manifesting into various health
                issues.
              </p>
              <p className="link">Read More</p>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </section>
  );
};

export default ManhoodEdit;
